import { render } from "./Programme.vue?vue&type=template&id=6f837fe2&scoped=true"
import script from "./Programme.vue?vue&type=script&lang=js"
export * from "./Programme.vue?vue&type=script&lang=js"

import "./Programme.vue?vue&type=style&index=0&id=6f837fe2&scoped=true&lang=css"

import exportComponent from "E:\\changjuCode\\official-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f837fe2"]])

export default __exports__